// FileUpload domain slice: image/document attachment state for the composer's upload
// path. Ownership/no-bridge rationale: .claude/context/store-slices.md ("fileUploadSlice").
export const fileUploadSlice = (set) => ({
  imageData: null,
  setImageData: (value) => set({ imageData: value }),
  isLoading: false,
  setIsLoading: (value) => set({ isLoading: value }),
  documentFile: null,
  setDocumentFile: (value) => set({ documentFile: value }),
  isDocumentLoading: false,
  setIsDocumentLoading: (value) => set({ isDocumentLoading: value }),
});
